
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import ChatController from '../../../controllers/Chat';

const msgHandler = msgable => {   // REVIEW REDUNDANTE en todos los formularios, SocialLogin y ChatSidebar
  if( msgable.msg) alert( msgable.msg);
}

const errorHandler = async executable => {
  try {
    await executable();
  } catch( error) {
    msgHandler( error);
  }
}

const Login = props => {

  const inputs = {
    mail: null, password: null,
  }

  const resendActivationToken = async () => {
    await errorHandler( async () => {
      const response = await ChatController.resendActivationToken( props.chatConfiguration, inputs.mail.value);
      msgHandler( response);
    });
  };

  const resetPassword = async () => {
    await errorHandler( async () => {
      const response = await ChatController.resetPassword( props.chatConfiguration, inputs.mail.value);
      msgHandler( response);
    });
  };

  const onSend = async () => {
    await errorHandler( async () => {
      const response = await ChatController.Login( props.chatConfiguration, inputs.mail.value, inputs.password.value);
      // msgHandler( response);   // DEBUG
      if( props.setLogin) props.setLogin( response.sessionToken);
    });
  };

  const enterHandler = async event => {
    if( event.key === 'Enter') await onSend();
  };

  useEffect( _ => {
    ReactDOM.findDOMNode( inputs.mail).focus();
  }, [ inputs.mail ]);

  return (
    <div className={'padding-input'}>
      <label> Email: </label>
      <input className={'form-control'} ref={ ref => inputs.mail = ref } onKeyDown={ enterHandler }></input>
      <label> Password: </label>
      <input className={'form-control'} ref={ ref => inputs.password = ref } type='password' onKeyDown={ enterHandler }></input>
      <button className={'cancel password'} onClick={ resendActivationToken }>Resend activation token</button><br/>
      <button className={'cancel password'} onClick={ resetPassword }>Don't you remember your password? Click here</button>
      <hr />
      <div className={'btn-group pull-right'}>
        <button className={'cancel'} onClick={ props.clearForm }> Cancel </button>
        <button className={'submit'} onClick={ onSend }> Log in </button>
      </div>
    </div>
  );
};

export default Login;
